/* src/components/LocalizedExpression.svelte generated by Svelte v3.57.0 */
import {
	SvelteComponent,
	component_subscribe,
	detach,
	init,
	insert,
	noop,
	safe_not_equal,
	set_data,
	text
} from "../../_snowpack/pkg/svelte/internal.js";

import { userStore } from "./stores.js";
import { addLocalization } from "../services/localizeExpressions.js";

function create_fragment(ctx) {
	let t_value = addLocalization(/*stringified*/ ctx[0], /*$userStore*/ ctx[1]) + "";
	let t;

	return {
		c() {
			t = text(t_value);
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		p(ctx, [dirty]) {
			if (dirty & /*stringified, $userStore*/ 3 && t_value !== (t_value = addLocalization(/*stringified*/ ctx[0], /*$userStore*/ ctx[1]) + "")) set_data(t, t_value);
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $userStore;
	component_subscribe($$self, userStore, $$value => $$invalidate(1, $userStore = $$value));
	let { stringified } = $$props;

	$$self.$$set = $$props => {
		if ('stringified' in $$props) $$invalidate(0, stringified = $$props.stringified);
	};

	return [stringified, $userStore];
}

class LocalizedExpression extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { stringified: 0 });
	}
}

export default LocalizedExpression;